// import { createSlice } from '@reduxjs/toolkit';
import { cleanCache } from '../../utils';
import * as api from '../../api';
import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

export const createAppSlice = buildCreateSlice({
	creators: { asyncThunk: asyncThunkCreator },
});

const initialState = {
	id: '',
	roles: [],
	permissions: [],
	email: '',
	isLoggedIn: false,
	loading: false,
};
export const userSlice = createAppSlice({
	name: 'user',
	initialState,
	reducers: (create) => ({
		setUser: create.reducer((state, action) => {
			const userInfo = action.payload;
			state.email = userInfo.email;
			state.id = userInfo.id;
			state.roles = userInfo.roles;
			state.permissions = userInfo.permissions;
			state.isLoggedIn = true;
		}),
		logout: create.reducer((state, _) => {
			state.email = '';
			state.id = '';
			state.roles = [];
			state.permissions = [];
			state.isLoggedIn = false;
			cleanCache();
		}),
		updateUserProfile: create.asyncThunk(
			async () => {
				const res = await api.getProfile();
				return res && res.responseData ? res.responseData : Promise.reject(res);
			},
			{
				pending: (state) => {
					state.loading = true;
				},
				rejected: (state, action) => {
					state.loading = false;
				},
				fulfilled: (state, action) => {
					console.log('>>>> updateUserProfile:' + JSON.stringify(action.payload));
					const userInfo = action.payload;
					state.email = userInfo.email;
					state.id = userInfo.id;
					state.roles = userInfo.roles;
					state.permissions = userInfo.permissions;

					state.loading = false;
				},
			},
		),
	}),
});
export const { setUser, logout, updateUserProfile } = userSlice.actions;
export default userSlice.reducer;
